"use client";

import Link from "next/link";

/**
 * When a page cannot be shown: most often, a login opening a page its role does not
 * include, such as a guide following a link to the System tab. In production the
 * reason is hidden, so this says the likely thing plainly and offers the way home.
 */
export default function ErrorPage({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <div className="wrap">
      <div className="mast">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img className="logo" src="/acton-logo-white.png" alt="Acton Academy Kennebunkport" />
        <h1>Not available</h1>
      </div>
      <div className="callout warn" style={{ marginTop: 20 }}>
        <b>Something went wrong, or this page isn&rsquo;t open to your login</b>
        The pad may have been updated while this page was open: reloading it usually fixes that.
        Your own work, your areas and the manual are always open to you.
      </div>
      <p>
        {/* First, because the commonest cause is a page opened before a deploy (2 October 2026):
            its buttons belong to the old pad until it is loaded again. */}
        <button type="button" className="btn mini go" onClick={() => window.location.reload()}>
          Reload the page
        </button>{" "}
        ·{" "}
        <Link href="/today" className="inlink">
          Go to My work
        </Link>{" "}
        ·{" "}
        <button type="button" className="btn mini" onClick={() => reset()}>
          Try again
        </button>
      </p>
    </div>
  );
}
